import React, { useContext } from "react"

import {
    GlobalDispatchContext,
    GlobalStateContext,
  } from "../context/GlobalContextProvider"

const ModeSwitcher = () => {
    const dispatch = useContext(GlobalDispatchContext);
    const state = useContext(GlobalStateContext);

    return (
        <div
            className="mode-switcher flex items-center cursor-pointer justify-center my-3"
            aria-hidden="true"
            onClick={() => {
                dispatch({ type: "TOGGLE_THEME" })
            }}
        >
            <svg width="20" height="20" viewBox="0 0 512 512" aria-hidden="true" focusable="false" data-icon="sun" role="img" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"></path></svg>
            <div className="ml-3 text-gray-700 font-medium"></div>
            <div className={`theme-${state.theme} relative`}>
                <div className="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                <div className="toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"></div>
            </div>
            <div className="ml-3 text-gray-700 font-medium"></div>
            <svg width="20" height="20" viewBox="0 0 512 512" aria-hidden="true" focusable="false" data-icon="moon" role="img" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"></path></svg>

        </div>
    )
}

export default ModeSwitcher
